<template>
    <v-dialog
        v-model="innerValue"
        v-bind="$attrs"
        max-width="400"
    >
        <v-card>
            <v-carousel
                :value="state"
                :continuous="false"
                :show-arrows="false"
                height="auto"
                hide-delimiters
                touchless
            >
                <v-carousel-item value="idle">
                    <v-container>
                        <v-row class="justify-space-between">
                            <v-col cols="auto">
                                <p class="font-weight-bold mb-0">
                                    {{ currencyCode }} <span class="font-weight-bold text-h5">{{ maxAmount }}</span>
                                </p>
                                <p><small>Balance</small></p>
                            </v-col>
                            <v-col cols="auto">
                                <v-chip color="primary">
                                    Beneficiary
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-card-text>
                        <!-- <v-text-field
                            v-model="email"
                            v-validate="'required|email'"
                            :error-messages="errors.first('email')"
                            label="Recipient's Kaoshi Email Address"
                            placeholder="email@example.com"
                            type="email"
                            name="email"
                            outlined
                        /> -->

                        <v-text-field
                            v-model="amount"
                            v-validate="'required'"
                            label="Amount"
                            name="amount"
                            type="number"
                            :min="0"
                            :max="maxAmount"
                            :prefix="currencyCode"
                            :rules="amountRules"
                            :error-messages="errors.first('amount')"
                            hide-details="auto"
                            outlined
                        />
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="primary white--text"
                            large
                            block
                            @click="withdraw"
                        >
                            Pay Now
                        </v-btn>
                    </v-card-actions>
                </v-carousel-item>

                <v-carousel-item value="success">
                    <v-card-title class="justify-center">
                        Transaction Created
                    </v-card-title>

                    <div class="d-flex justify-center">
                        <v-img
                            src="/images/undraw_loading_re_5axr.svg"
                            max-width="225"
                        />
                    </div>

                    <v-card-text>
                        <p class="text-center">
                            Waiting on Admin Approval
                        </p>

                        <v-row>
                            <v-col>
                                <v-btn
                                    x-small
                                    @click="reset"
                                >
                                    Transact Again
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn x-small>
                                    Share
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn x-small>
                                    Get Receipt
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="primary white--text"
                            large
                            block
                            @click="innerValue = false"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-carousel-item>
            </v-carousel>
        </v-card>

        <v-overlay
            :value="loading"
            absolute
        >
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
            />
        </v-overlay>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false,
        },
        totalAmount: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    data: () => ({
        loading: false,
        state: 'idle',
        amount: null,
        email: null,
    }),
    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        maxAmount() {
            return this.totalAmount.amount || 0;
        },
        currencyCode() {
            return this.totalAmount.currency_code;
        },
        amountRules() {
            return [
                (value) => {
                    const min = 0;
                    const max = this.maxAmount;

                    if (value < min) return `Amount should be above ${min.toFixed(2)}`;
                    if (value > max) return `Amount should be below ${max.toFixed(2)}`;

                    return true;
                },
            ];
        },
    },
    methods: {
        async withdraw() {
            try {
                const valid = await this.$validator.validateAll();
                if (!valid) return;

                this.loading = true;
                const { amount, currencyCode } = this;

                // await Vue.backendApi()
                //     .user()
                //     .fetchKaoshiUser(email);

                await Vue.backendApi()
                    .referralTransactions()
                    .withdraw({
                        amount,
                        currency_code: currencyCode,
                        // beneficiary_email: email,
                    });
                this.state = 'success';
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: error,
                });
            } finally {
                this.loading = false;
            }
        },
        reset() {
            this.state = 'idle';
            this.amount = null;
            this.email = null;
            this.$validator.reset();
        },
    },
};
</script>
